// Stage 1: density uses diameter² (not radius²) — matches spec test cases.
var psUnit = 'cm';
var psCurrentStyle = 'neapolitan';

// True while the page-load path (psSelectStyle's default style, or
// psLoadFromURL's restore) is driving psCalc()/ps2Calc() programmatically,
// so calc.run isn't recorded for a visitor who merely opened the page.
// Matches the suite's trackCalculation(), which only ever runs from inside
// a calculate function a user actually triggered, never from page init.
var psInitializing = true;

// Pizzeria thickness factor (oz of dough per square inch of pizza) to this
// file's density (grams per cm of diameter squared): g = PI * d_cm^2 * density
// = area_in2 * tf * 28.3495, so density = tf * 28.3495 / 25.8064. New York and
// thin and crispy use the standard factors (0.090, 0.070), the same as the
// dough ball weight calculator; Benjie chose these on 13 Oct 2026.
function fromTf(tf) { return tf * 28.3495 / 25.8064; }

// Pan (rect) styles carry the thickness factor itself: grams = area_in2 * tf *
// 28.3495, with the pan measured in cm (area_in2 = w_cm * h_cm / 6.4516).
// Detroit (0.130) and Sicilian (0.120) are the dough ball weight calculator's
// factors (PP_STYLES), and their hydration, salt and oil match it too (that
// calculator also adds 1% sugar; Pizza Studio has no sugar). Roman teglia
// (0.120) and focaccia (0.160) have no equivalent there: proposed values,
// awaiting Benjie's confirmation. Benjie moved pan styles to thickness
// factors on 14 Oct 2026.
function rectWeight(wCm, hCm, tf) { return (wCm * hCm / 6.4516) * tf * 28.3495; }

var psData = {
  neapolitan: {
    shape: 'circle',
    defaultDiam: 30, defaultW: null, defaultH: null,
    density: 0.085, hydration: 0.65, fat: 0, salt: 2.5,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: 'As hot as your oven goes, ideally 400C+ in a wood-fired or pizza oven.',
    desc: 'Thin, wood-fired crust with a soft, pillowy centre and characteristic leopard char on the base.',
    tip: 'Keep your dough ball tight and smooth — surface tension is everything with Neapolitan.'
  },
  roman: {
    shape: 'rect',
    defaultDiam: null, defaultW: 40, defaultH: 30,
    tf: 0.120, hydration: 0.75, fat: 0, salt: 2.5,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: '250C, oiled tray on the bottom shelf.',
    desc: 'High-hydration pan pizza baked in a rectangular tray, with a crispy base and an open, airy interior.',
    tip: 'Oil the tray generously — teglia dough is very wet, and that oil forms the signature crispy bottom.'
  },
  ny: {
    shape: 'circle',
    defaultDiam: 35, defaultW: null, defaultH: null,
    density: fromTf(0.090), hydration: 0.62, fat: 0.03, salt: 2.5,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: '260C on a preheated steel or stone.',
    desc: 'Large, foldable slices with a chewy, oil-enriched crumb and that classic fold-in-half structure.',
    tip: 'Let the dough prove in the tray for at least 2 hours before topping for that proper NY structure.'
  },
  detroit: {
    shape: 'rect',
    defaultDiam: null, defaultW: 25, defaultH: 35,
    tf: 0.130, hydration: 0.72, fat: 0.02, salt: 2.0,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: '245C, well-oiled steel pan.',
    desc: 'Thick, focaccia-adjacent pan pizza with caramelised cheese edges and a pillowy, pull-apart interior.',
    tip: 'Cheese goes all the way to the pan edges before baking — the caramelised crust rim is the signature.'
  },
  focaccia: {
    shape: 'rect',
    defaultDiam: null, defaultW: 30, defaultH: 40,
    tf: 0.160, hydration: 0.78, fat: 0.05, salt: 2.5,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: '220C, generously oiled tray.',
    desc: 'Olive oil-enriched flatbread, dimpled and golden, built for soaking up flavour and topping generously.',
    tip: 'Be generous with olive oil in the dough and on top — focaccia should glisten when it comes out.'
  },
  sicilian: {
    shape: 'rect',
    defaultDiam: null, defaultW: 33, defaultH: 23,
    tf: 0.120, hydration: 0.70, fat: 0.03, salt: 2.0,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: '230C, well-oiled steel pan for a crisp, fried-feeling base.',
    desc: 'Thick, square-cut pan pizza with a light, airy crumb and a crisp, almost-fried base from the oiled pan.',
    tip: 'Let the dough relax in the pan for 20 to 30 minutes before stretching it to the edges, it fights back less.'
  },
  thincrispy: {
    shape: 'circle',
    defaultDiam: 32, defaultW: null, defaultH: null,
    density: fromTf(0.070), hydration: 0.55, fat: 0.03, salt: 2.0,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: '230C, thin and even, docked to stop bubbling.',
    desc: 'Cracker-thin, low-hydration base that bakes flat and crisp all the way through, no chew, all snap.',
    tip: 'Dock the base all over with a fork before topping, it stops it puffing up unevenly in the oven.'
  },
  sourdough: {
    shape: 'circle',
    defaultDiam: 30, defaultW: null, defaultH: null,
    density: 0.085, hydration: 0.65, fat: 0, salt: 2.5,
    preFerment: 'levain', preFermentPct: 20,
    ovenHint: 'As hot as your oven goes. Sourdough pizza still wants a screaming-hot oven.',
    desc: 'Neapolitan-style base leavened entirely with a mature sourdough starter instead of commercial yeast.',
    tip: 'Feed your starter 4 to 6 hours before mixing so it is at its peak rise and smells properly sour-sweet.'
  }
};

function psSelectStyle(style) {
  psCurrentStyle = style;
  var s = psData[style];

  document.querySelectorAll('.ps-style-card').forEach(function(c) {
    c.classList.toggle('ps-active', c.getAttribute('data-style') === style);
  });

  var isCircle = (s.shape === 'circle');
  document.getElementById('ps-circle-field').style.display = isCircle ? '' : 'none';
  document.getElementById('ps-rect-field').style.display = isCircle ? 'none' : '';

  if (isCircle) {
    var diam = s.defaultDiam;
    if (psUnit === 'in') { diam = parseFloat((diam / 2.54).toFixed(2)); }
    document.getElementById('ps-diameter').value = diam;
  } else {
    document.getElementById('ps-width').value = s.defaultW;
    document.getElementById('ps-height').value = s.defaultH;
  }

  psCalc();
}

function psToggleUnit() {
  var el = document.getElementById('ps-diameter');
  var val = parseFloat(el.value) || 0;
  var lbl = document.getElementById('ps-diam-label');
  if (psUnit === 'cm') {
    psUnit = 'in';
    el.value = parseFloat((val / 2.54).toFixed(2));
    lbl.textContent = 'Diameter (in)';
  } else {
    psUnit = 'cm';
    el.value = parseFloat((val * 2.54).toFixed(1));
    lbl.textContent = 'Diameter (cm)';
  }
  psCalc();
}

function psCalc() {
  var s = psData[psCurrentStyle];
  var balls = parseInt(document.getElementById('ps-ball-count').value, 10) || 1;
  if (balls < 1) balls = 1;
  if (balls > 20) balls = 20;

  var ballWeight = 0;

  if (s.shape === 'circle') {
    var rawDiam = parseFloat(document.getElementById('ps-diameter').value) || 0;
    var diamCm = (psUnit === 'in') ? rawDiam * 2.54 : rawDiam;
    // Formula uses diameter² — density values are calibrated accordingly
    ballWeight = Math.PI * diamCm * diamCm * s.density;
  } else {
    var w = parseFloat(document.getElementById('ps-width').value) || 0;
    var h = parseFloat(document.getElementById('ps-height').value) || 0;
    ballWeight = rectWeight(w, h, s.tf);
  }

  var total = ballWeight * balls;

  document.getElementById('ps-weight-per-ball').innerHTML =
    ballWeight.toFixed(1) + '<span class="ps-result-unit"> g</span>';
  document.getElementById('ps-total-weight').innerHTML =
    total.toFixed(1) + '<span class="ps-result-unit"> g</span>';

  document.getElementById('ps-style-desc').textContent = s.desc;
  document.getElementById('ps-style-tip').innerHTML =
    '<span class="ps-tip-label">Tip</span>' + s.tip;
  var ovenEl = document.getElementById('ps-style-oven');
  if (ovenEl) ovenEl.innerHTML = '<span class="ps-tip-label">Oven</span>' + s.ovenHint;

  // Populate global state for Stages 2–3
  window.ps = {
    style: psCurrentStyle,
    ballWeight: parseFloat(ballWeight.toFixed(1)),
    totalDough: parseFloat(total.toFixed(1)),
    hydration: s.hydration,
    salt: s.salt,
    fat: s.fat,
    preFerment: s.preFerment,
    preFermentPct: s.preFermentPct
  };
  // Sync Stage 2 whenever Stage 1 changes
  if (typeof ps2Init === 'function') ps2Init();
}


var ps2FlourMode = 'single';
var ps2CurrentPF = 'levain';

function ps2SetFlourMode(mode, e) {
  ps2FlourMode = mode;
  document.querySelectorAll('.ps2-toggle-btn').forEach(function(b) {
    b.classList.remove('ps2-btn-active');
  });
  e.target.classList.add('ps2-btn-active');
  document.getElementById('ps2-flour-single').style.display = (mode === 'single') ? '' : 'none';
  document.getElementById('ps2-flour-dual').style.display = (mode === 'dual') ? '' : 'none';
  ps2Calc();
}

function ps2SyncDualPct(changed) {
  var aEl = document.getElementById('ps2-flour-a-pct');
  var bEl = document.getElementById('ps2-flour-b-pct');
  var a = parseFloat(aEl.value) || 0;
  if (a < 1) a = 1;
  if (a > 99) a = 99;
  aEl.value = a;
  bEl.value = 100 - a;
}

function ps2SyncHydration() {
  var val = document.getElementById('ps2-hydration').value;
  document.getElementById('ps2-hydration-val').textContent = parseFloat(val).toFixed(1).replace('.0','');
  ps2Calc();
}

function ps2SelectPF(pf) {
  ps2CurrentPF = pf;
  document.querySelectorAll('.ps2-pf-card').forEach(function(c) {
    c.classList.toggle('ps2-pf-active', c.getAttribute('data-pf') === pf);
  });
  var panels = ['levain', 'poolish', 'biga'];
  panels.forEach(function(p) {
    var el = document.getElementById('ps2-pf-' + p + '-inputs');
    if (el) el.style.display = (p === pf) ? '' : 'none';
  });
  ps2Calc();
}

var ps2CurrentYeast = 'idy';

function ps2SelectYeast(yt) {
  ps2CurrentYeast = yt;
  document.querySelectorAll('.ps2-yeast-btn').forEach(function(b) {
    b.classList.toggle('ps2-btn-active', b.getAttribute('data-yeast') === yt);
  });
  ps2Calc();
}

var ps2ScheduleOn = false;

function ps2IsMixedSchedule() {
  var el = document.getElementById('ps2-sched-mixed');
  return !!el && el.style.display !== 'none';
}

function ps2ToggleSchedule() {
  ps2ScheduleOn = !ps2ScheduleOn;
  var panel = document.getElementById('ps2-schedule-panel');
  var btn = document.getElementById('ps2-schedule-toggle-btn');
  if (panel) panel.style.display = ps2ScheduleOn ? '' : 'none';
  if (btn) btn.textContent = ps2ScheduleOn ? 'Hide schedule' : 'Plan by time and temperature';
  ps2Calc();
}

function ps2ScheduleMode(mode, e) {
  document.querySelectorAll('.ps2-sched-mode-btn').forEach(function(b) {
    b.classList.remove('ps2-btn-active');
  });
  if (e) e.target.classList.add('ps2-btn-active');
  var single = (mode === 'single');
  document.getElementById('ps2-sched-single').style.display = single ? '' : 'none';
  document.getElementById('ps2-sched-mixed').style.display = single ? 'none' : '';
  ps2Calc();
}

// Q10 solver, ported from calcYeastSolver in sections/calculators-suite-2.liquid.
// Base 0.2% IDY at 20C = 12h bulk; factor 2^((t-20)/10). Kept identical so
// Pizza Studio and the standalone Yeast solver never disagree on the same inputs.
// The solver itself lives in assets/dr-pizza-maths.js, shared with the homepage docket.
function ps2SolveYeast(hours, tempC) {
  return window.DRPizzaMaths.solveYeast(hours, tempC);
}

// Mixed room+fridge schedule: the fridge is colder, so each fridge hour buys
// less fermentation progress than a room hour (Q10 factor > 1 for room>fridge),
// so fridge hours are DIVIDED by that factor to get their room-equivalent
// contribution, then solved as one continuous room-temp ferment.
function ps2SolveYeastMixed(roomHours, roomTemp, fridgeHours, fridgeTemp) {
  return window.DRPizzaMaths.solveYeastMixed(roomHours, roomTemp, fridgeHours, fridgeTemp);
}

// Sourdough starter percent: same Q10 factor scaled from a 20% @ 12h/22C
// reference, clamped to a workable 5-35% range per the pack's spec.
function ps2SolveStarterPct(hours, tempC) {
  var baseS = 20, baseT = 22, baseBH = 12;
  var safeHours = Math.max(0.25, hours || 0);
  var pct = (baseBH * baseS) / (safeHours * Math.pow(2, (tempC - baseT) / 10));
  return Math.max(5, Math.min(35, pct));
}

// Mixed room+fridge starter: same room-equivalent-hours conversion as
// ps2SolveYeastMixed, since cold fridge hours ferment slower than room hours.
function ps2SolveStarterPctMixed(roomHours, roomTemp, fridgeHours, fridgeTemp) {
  var effectiveFridgeHours = fridgeHours / Math.pow(2, (roomTemp - fridgeTemp) / 10);
  var totalEffectiveHours = roomHours + effectiveFridgeHours;
  return ps2SolveStarterPct(totalEffectiveHours, roomTemp);
}

function ps2BuildScheduleSummary(hours, singleTemp, roomHours, roomTemp, fridgeHours, fridgeTemp) {
  var parts = ['Mix'];
  if (fridgeHours > 0) {
    parts.push('bulk ' + roomHours + 'h at ' + ps2FormatTemp(roomTemp));
    parts.push('ball');
    parts.push('fridge ' + fridgeHours + 'h at ' + ps2FormatTemp(fridgeTemp));
  } else {
    parts.push('bulk ' + hours + 'h at ' + ps2FormatTemp(singleTemp));
    parts.push('ball');
  }
  parts.push('bake');
  return parts.join(', ');
}

function ps2Calc() {
  var flourWeight = parseFloat(document.getElementById('ps2-flour-weight').value) || 0;
  if (flourWeight <= 0) return;

  var hydration = parseFloat(document.getElementById('ps2-hydration').value) / 100;
  var saltPct = parseFloat(document.getElementById('ps2-salt').value) || 0;
  var fatPct = parseFloat(document.getElementById('ps2-fat').value) || 0;

  var totalWater = flourWeight * hydration;
  var saltWeight = (saltPct / 100) * flourWeight;
  var fatWeight = (fatPct / 100) * flourWeight;

  // Blended protein
  var blendedProtein = null;
  if (ps2FlourMode === 'dual') {
    var pA = parseFloat(document.getElementById('ps2-flour-a-pct').value) || 0;
    var prA = parseFloat(document.getElementById('ps2-flour-a-prot').value) || 0;
    var pB = 100 - pA;
    var prB = parseFloat(document.getElementById('ps2-flour-b-prot').value) || 0;
    document.getElementById('ps2-flour-b-pct').value = pB;
    blendedProtein = (pA / 100 * prA) + (pB / 100 * prB);
    document.getElementById('ps2-blend-prot').textContent = blendedProtein.toFixed(1) + '%';
  }

  // Pre-ferment calculations
  var pfFlour = 0, pfWater = 0, pfTotal = 0;
  var pfLabel = '';

  if (ps2CurrentPF === 'levain') {
    var pct = parseFloat(document.getElementById('ps2-levain-pct').value) || 0;
    var lHyd = parseFloat(document.getElementById('ps2-levain-hyd').value) || 100;
    pfFlour = (pct / 100) * flourWeight;
    pfWater = pfFlour * (lHyd / 100);
    pfTotal = pfFlour + pfWater;
    pfLabel = 'Sourdough Levain';
  } else if (ps2CurrentPF === 'poolish') {
    var pct = parseFloat(document.getElementById('ps2-poolish-pct').value) || 0;
    pfFlour = (pct / 100) * flourWeight;
    pfWater = pfFlour;
    pfTotal = pfFlour * 2;
    pfLabel = 'Poolish';
  } else if (ps2CurrentPF === 'biga') {
    var pct = parseFloat(document.getElementById('ps2-biga-pct').value) || 0;
    var bHyd = parseFloat(document.getElementById('ps2-biga-hyd').value) || 50;
    pfFlour = (pct / 100) * flourWeight;
    pfWater = pfFlour * (bHyd / 100);
    pfTotal = pfFlour + pfWater;
    pfLabel = 'Biga';
  }

  var mainFlour = flourWeight - pfFlour;
  var mainWater = totalWater - pfWater;
  var actualHydration = (totalWater / flourWeight * 100).toFixed(1);
  var totalDough = flourWeight + totalWater + saltWeight + fatWeight;

  // Yeast / starter solve: only when there is no formal pre-ferment build,
  // since levain/poolish/biga already carry the leavening in pfTotal above.
  // Computed before the HTML/mainFlour rows are built so a sourdough starter
  // (which consumes flour+water like a pre-ferment) is reflected in totals.
  var yeastLine = null, scheduleSummary = null;
  var showStarterAsPF = false, starterFlour = 0, starterWater = 0, starterWeight = 0, starterPct = 0;
  if (ps2CurrentPF === 'none') {
    var ySingleTemp = parseFloat(document.getElementById('ps2-sched-temp').value) || 22;
    var yHours = parseFloat(document.getElementById('ps2-sched-hours').value) || 24;
    var yRoomHours = parseFloat(document.getElementById('ps2-sched-room-hours').value) || 0;
    var yRoomTemp = parseFloat(document.getElementById('ps2-sched-room-temp').value) || 22;
    var yFridgeHours = parseFloat(document.getElementById('ps2-sched-fridge-hours').value) || 0;
    var yFridgeTemp = parseFloat(document.getElementById('ps2-sched-fridge-temp').value) || 4;
    var isMixed = ps2IsMixedSchedule();

    if (ps2CurrentYeast === 'starter') {
      showStarterAsPF = true;
      starterPct = ps2ScheduleOn
        ? (isMixed ? ps2SolveStarterPctMixed(yRoomHours, yRoomTemp, yFridgeHours, yFridgeTemp) : ps2SolveStarterPct(yHours, ySingleTemp))
        : 20;
      // A 100%-hydration starter is half flour, half water by weight; both
      // sides come out of the main dough totals so the totals stay accurate.
      starterWeight = flourWeight * (starterPct / 100);
      starterFlour = starterWeight / 2;
      starterWater = starterWeight / 2;
      mainFlour -= starterFlour;
      mainWater -= starterWater;
    } else {
      var solved = ps2ScheduleOn
        ? (isMixed ? ps2SolveYeastMixed(yRoomHours, yRoomTemp, yFridgeHours, yFridgeTemp) : ps2SolveYeast(yHours, ySingleTemp))
        : { idy: 0.2, ady: 0.3, fresh: 0.6 };
      var yeastPct = solved[ps2CurrentYeast] || solved.idy;
      var yeastWeight = flourWeight * (yeastPct / 100);
      var yeastLabel = ps2CurrentYeast === 'ady' ? 'Yeast (ADY)' : ps2CurrentYeast === 'fresh' ? 'Yeast (fresh)' : 'Yeast (IDY)';
      yeastLine = '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label">' + yeastLabel + '</span><span class="ps2-recipe-row-val">' + yeastWeight.toFixed(2) + ' g (' + yeastPct.toFixed(3) + '%)</span></div>';
    }

    if (ps2ScheduleOn) {
      scheduleSummary = isMixed
        ? ps2BuildScheduleSummary(null, null, yRoomHours, yRoomTemp, yFridgeHours, yFridgeTemp)
        : ps2BuildScheduleSummary(yHours, ySingleTemp, 0, 0, 0, 0);
    }
  }

  // Water display hint
  document.getElementById('ps2-water-display').textContent = ps2FormatWeight(totalWater);

  // Build recipe card HTML
  var styleName = (window.ps && window.ps.style) ? window.ps.style.charAt(0).toUpperCase() + window.ps.style.slice(1) : '';
  document.getElementById('ps2-recipe-style-label').textContent = styleName;

  var html = '';

  if (ps2CurrentPF !== 'none') {
    html += '<div class="ps2-recipe-section-label">' + pfLabel + '</div>';
    html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label">' + pfLabel + ' total</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(pfTotal) + '</span></div>';
    html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label ps2-sub">&#x2514; Flour</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(pfFlour) + '</span></div>';
    html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label ps2-sub">&#x2514; Water</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(pfWater) + '</span></div>';
  } else if (showStarterAsPF) {
    html += '<div class="ps2-recipe-section-label">Sourdough Starter</div>';
    html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label">Starter total</span><span class="ps2-recipe-row-val">' + starterWeight.toFixed(1) + ' g (' + starterPct.toFixed(1) + '%)</span></div>';
    html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label ps2-sub">&#x2514; Flour</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(starterFlour) + '</span></div>';
    html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label ps2-sub">&#x2514; Water</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(starterWater) + '</span></div>';
  }

  var hasPreFerment = (ps2CurrentPF !== 'none') || showStarterAsPF;
  html += '<div class="ps2-recipe-section-label">Main Dough</div>';
  html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label">Flour' + (hasPreFerment ? ' (remaining)' : '') + '</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(mainFlour) + '</span></div>';
  html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label">Water' + (hasPreFerment ? ' (remaining)' : '') + '</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(mainWater) + '</span></div>';
  html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label">Salt</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(saltWeight) + '</span></div>';
  if (fatWeight > 0) {
    html += '<div class="ps2-recipe-row"><span class="ps2-recipe-row-label">Fat</span><span class="ps2-recipe-row-val">' + ps2FormatWeight(fatWeight) + '</span></div>';
  }

  if (yeastLine) html += yeastLine;

  html += '<div class="ps2-recipe-totals">';
  html += '<div class="ps2-recipe-total-row"><span class="ps2-recipe-total-label">Total flour</span><span class="ps2-recipe-total-val">' + ps2FormatWeight(flourWeight) + '</span></div>';
  html += '<div class="ps2-recipe-total-row"><span class="ps2-recipe-total-label">Total water</span><span class="ps2-recipe-total-val">' + ps2FormatWeight(totalWater) + '</span></div>';
  html += '<div class="ps2-recipe-total-row"><span class="ps2-recipe-total-label">Actual hydration</span><span class="ps2-recipe-total-val">' + actualHydration + '%</span></div>';
  html += '<div class="ps2-recipe-total-row"><span class="ps2-recipe-total-label">Total dough weight</span><span class="ps2-recipe-total-val">' + ps2FormatWeight(totalDough) + '</span></div>';
  if (blendedProtein !== null) {
    html += '<div class="ps2-recipe-total-row"><span class="ps2-recipe-total-label">Blended protein</span><span class="ps2-recipe-total-val">' + blendedProtein.toFixed(1) + '%</span></div>';
  }
  html += '</div>';

  if (scheduleSummary) {
    html += '<div class="ps2-schedule-summary">' + scheduleSummary + '</div>';
  }

  document.getElementById('ps2-recipe-body').innerHTML = html;

  // Update window.ps
  if (window.ps) {
    window.ps.preFerment = ps2CurrentPF;
    window.ps.preFermentPct = ps2CurrentPF === 'levain' ? (parseFloat(document.getElementById('ps2-levain-pct').value)||0) :
                               ps2CurrentPF === 'poolish' ? (parseFloat(document.getElementById('ps2-poolish-pct').value)||0) :
                               ps2CurrentPF === 'biga' ? (parseFloat(document.getElementById('ps2-biga-pct').value)||0) : 0;
    window.ps.levainHydration = ps2CurrentPF === 'levain' ? (parseFloat(document.getElementById('ps2-levain-hyd').value)||100) : null;
    window.ps.hydration = hydration;
    window.ps.salt = saltPct;
    window.ps.fat = fatPct;
    window.ps.flourWeight = flourWeight;
    window.ps.waterWeight = parseFloat(totalWater.toFixed(1));
    window.ps.saltWeight = parseFloat(saltWeight.toFixed(1));
    window.ps.fatWeight = parseFloat(fatWeight.toFixed(1));
    window.ps.recipe = {
      pfLabel: showStarterAsPF ? 'Sourdough Starter' : pfLabel,
      pfFlour: showStarterAsPF ? starterFlour : pfFlour,
      pfWater: showStarterAsPF ? starterWater : pfWater,
      pfTotal: showStarterAsPF ? starterWeight : pfTotal,
      mainFlour: mainFlour, mainWater: mainWater,
      totalFlour: flourWeight, totalWater: totalWater,
      blendedProtein: blendedProtein,
      // Commercial yeast only (a starter is the pre-ferment line); read by psFormulaText.
      yeastLabel: (typeof yeastWeight === 'number') ? yeastLabel : '',
      yeastWeight: (typeof yeastWeight === 'number') ? yeastWeight : 0
    };
    window.ps.yeastType = ps2CurrentYeast;
    window.ps.scheduleOn = ps2ScheduleOn;
    window.ps.scheduleSummary = scheduleSummary;
  }

  if (typeof psUpdateURL === 'function') psUpdateURL();
  psTrackCalcRun();
}

// Mirrors trackCalculation()'s once-per-session calc.run signal (calculators-suite.liquid)
// so Pizza Studio counts toward the same aha-nudge funnel as the other 25 calculators.
// ps2Calc() fires on every keystroke/slider-tick, so this is throttled to once per session
// rather than firing on every call like the suite's per-click tracker does.
function psTrackCalcRun() {
  if (psInitializing) return;
  if (window.drGa4CalcUsed) window.drGa4CalcUsed('pizza-studio', 'pizza-studio');
  if (window.__drIsPro) return;
  try {
    if (!sessionStorage.getItem('dr_calc_run_sent') && window.drFireEvent) {
      window.drFireEvent('calc.run', { tool: 'pizza-studio' });
      sessionStorage.setItem('dr_calc_run_sent', '1');
    }
  } catch (e) {}
}

function ps2Init() {
  if (!window.ps || !window.ps.totalDough) return;

  // Set hydration from style default
  var hPct = Math.round(window.ps.hydration * 100 * 2) / 2; // snap to 0.5
  document.getElementById('ps2-hydration').value = hPct;
  document.getElementById('ps2-hydration-val').textContent = hPct;

  // Fat: show field if style has fat, hide if not
  var fatField = document.getElementById('ps2-fat-field');
  var fatPct = 0;
  if (window.ps.fat > 0) {
    fatField.style.display = '';
    fatPct = Math.round(window.ps.fat * 100 * 2) / 2;
    document.getElementById('ps2-fat').value = fatPct;
  } else {
    fatField.style.display = 'none';
    // Clear it, or a hidden 3% from New York would still add oil to a
    // Neapolitan recipe after switching style.
    document.getElementById('ps2-fat').value = 0;
  }

  // Back-solve flour weight from Stage 1's total dough weight, since
  // #ps2-flour-weight is treated as pure flour by ps2Calc (which derives
  // water/salt/fat from it as percentages) — writing total dough weight in
  // directly inflated every downstream number by roughly
  // (1 + hydration + salt% + fat%). Mirrors scripts/lib/pizza-formulas.js's
  // calcDough, kept in sync so the two never disagree on the same inputs.
  // Salt from the style default too, as hydration above. Before this the box
  // stayed at 2.5% for every style while the flour was back-solved with the
  // style's salt (2.0% for Detroit, Sicilian and thin and crispy).
  var saltPct = window.ps.salt || 0;
  document.getElementById('ps2-salt').value = saltPct;
  var flourWeight = window.ps.totalDough / (1 + (hPct / 100) + (saltPct / 100) + (fatPct / 100));
  document.getElementById('ps2-flour-weight').value = flourWeight.toFixed(1);

  ps2Calc();
}



// Recipe-output imperial toggle: converts the rendered grams to oz and the
// schedule temperature fields to Fahrenheit. Mirrors psToggleUnit's cm/in
// pattern but only touches the Stage 2 output, not the Stage 1 size inputs.
var ps2RecipeUnit = 'metric';

function ps2ToggleRecipeUnit() {
  ps2RecipeUnit = (ps2RecipeUnit === 'metric') ? 'imperial' : 'metric';
  var btn = document.getElementById('ps2-recipe-unit-btn');
  if (btn) btn.textContent = (ps2RecipeUnit === 'metric') ? 'g / C ↔ oz / F' : 'oz / F ↔ g / C';
  ps2Calc();
}

function ps2FormatWeight(grams) {
  if (ps2RecipeUnit === 'imperial') {
    return (grams / 28.3495).toFixed(2) + ' oz';
  }
  return grams.toFixed(1) + ' g';
}

function ps2FormatTemp(celsius) {
  if (ps2RecipeUnit === 'imperial') {
    return Math.round(celsius * 9 / 5 + 32) + 'F';
  }
  return celsius + 'C';
}

// Plain-text recipe to clipboard.
// The plan as plain text: what Copy formula copies and what the email capture sends.
function psFormulaText() {
  var ps = window.ps || {};
  var r = ps.recipe || {};
  var lines = [];
  lines.push('DoughRise Pizza Studio, ' + (ps.style ? ps.style.charAt(0).toUpperCase() + ps.style.slice(1) : '') + ' formula');
  lines.push('');
  if (r.pfLabel && (ps.preFerment !== 'none' || ps.yeastType === 'starter')) {
    lines.push(r.pfLabel + ': ' + ps2FormatWeight(r.pfFlour) + ' flour, ' + ps2FormatWeight(r.pfWater) + ' water');
  }
  lines.push('Flour: ' + ps2FormatWeight(r.totalFlour || 0));
  var hydPct = ps.hydration ? Math.round(ps.hydration * 100) : 0;
  lines.push('Water: ' + ps2FormatWeight(r.totalWater || 0) + ' (' + hydPct + '%)');
  lines.push('Salt: ' + ps2FormatWeight(ps.saltWeight || 0));
  if (r.yeastLabel && r.yeastWeight) lines.push(r.yeastLabel + ': ' + r.yeastWeight.toFixed(2) + ' g');
  if (ps.fatWeight) lines.push('Fat: ' + ps2FormatWeight(ps.fatWeight));
  if (ps.scheduleSummary) lines.push('Schedule: ' + ps.scheduleSummary);
  lines.push('');
  lines.push('doughrise.store/pages/pizza-studio');
  return lines.join('\n');
}

function psCopyFormula() {
  var text = psFormulaText();
  var btn = document.getElementById('ps-copy-formula-btn');

  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(text).then(function() {
      psShowCopyFeedback(btn, 'Copied');
      psTrackShare();
      psTrackExport('copy');
    }, function() {
      psShowCopyFeedback(btn, 'Copy failed');
    });
    return;
  }

  psShowCopyFeedback(btn, 'Copied');
  psTrackShare();
  psTrackExport('copy');
}

// recipe.exported signal for the instrumentation funnel (prompt 08): fired on
// copy-to-clipboard and Pro handoff, the two points a user takes a formula out
// of Pizza Studio. Free users only, best-effort, matches the safelist in
// doughrise-api's /api/events/client (src/routes/events-client.ts).
function psTrackExport(action) {
  if (window.__drIsPro) return;
  if (window.drFireEvent) window.drFireEvent('recipe.exported', { tool: 'pizza-studio', action: action });
}

function psShowCopyFeedback(btn, label) {
  if (!btn) return;
  var original = btn.textContent;
  btn.textContent = label;
  setTimeout(function() { btn.textContent = original; }, 1800);
}

// URL state, mirroring SHARE_MAPS' short-key convention in calculators-suite.liquid
// so programmatic pages can target either tool with the same query-string shape.
var PS_SHARE_MAP = {
  st: 'ps-style-select', n: 'ps-ball-count', u: null, d: 'ps-diameter', w: 'ps-width', ht: 'ps-height',
  h: 'ps2-hydration', s: 'ps2-salt', f: 'ps2-fat',
  pf: 'ps2-pf-select', pfp: 'ps2-levain-pct', lh: 'ps2-levain-hyd',
  pp: 'ps2-poolish-pct', bp: 'ps2-biga-pct', bh: 'ps2-biga-hyd',
  yt: 'ps2-yeast-select',
  t: 'ps2-sched-hours', rt: 'ps2-sched-temp',
  rh: 'ps2-sched-room-hours', rct: 'ps2-sched-room-temp',
  fh: 'ps2-sched-fridge-hours', ft: 'ps2-sched-fridge-temp'
};

function psGenerateShareURL() {
  var ps = window.ps || {};
  var params = [];
  params.push('st=' + encodeURIComponent(psCurrentStyle));
  params.push('n=' + encodeURIComponent(document.getElementById('ps-ball-count').value));
  // Diameter is stored in whichever unit psUnit currently is (cm or in), so the
  // unit must travel with it or the recipient's default 'cm' silently misreads it.
  params.push('u=' + encodeURIComponent(psUnit));
  if (document.getElementById('ps-diameter').value) params.push('d=' + encodeURIComponent(document.getElementById('ps-diameter').value));
  if (document.getElementById('ps-width') && document.getElementById('ps-width').value) params.push('w=' + encodeURIComponent(document.getElementById('ps-width').value));
  if (document.getElementById('ps-height') && document.getElementById('ps-height').value) params.push('ht=' + encodeURIComponent(document.getElementById('ps-height').value));
  params.push('h=' + encodeURIComponent(document.getElementById('ps2-hydration').value));
  params.push('s=' + encodeURIComponent(document.getElementById('ps2-salt').value));
  params.push('f=' + encodeURIComponent(document.getElementById('ps2-fat').value));
  params.push('pf=' + encodeURIComponent(ps2CurrentPF));
  if (ps2CurrentPF === 'levain') {
    params.push('pfp=' + encodeURIComponent(document.getElementById('ps2-levain-pct').value));
    params.push('lh=' + encodeURIComponent(document.getElementById('ps2-levain-hyd').value));
  } else if (ps2CurrentPF === 'poolish') {
    params.push('pp=' + encodeURIComponent(document.getElementById('ps2-poolish-pct').value));
  } else if (ps2CurrentPF === 'biga') {
    params.push('bp=' + encodeURIComponent(document.getElementById('ps2-biga-pct').value));
    params.push('bh=' + encodeURIComponent(document.getElementById('ps2-biga-hyd').value));
  }
  params.push('yt=' + encodeURIComponent(ps2CurrentYeast));
  if (ps2ScheduleOn) {
    var isMixed = ps2IsMixedSchedule();
    if (isMixed) {
      params.push('rh=' + encodeURIComponent(document.getElementById('ps2-sched-room-hours').value));
      params.push('rct=' + encodeURIComponent(document.getElementById('ps2-sched-room-temp').value));
      params.push('fh=' + encodeURIComponent(document.getElementById('ps2-sched-fridge-hours').value));
      params.push('ft=' + encodeURIComponent(document.getElementById('ps2-sched-fridge-temp').value));
    } else {
      params.push('t=' + encodeURIComponent(document.getElementById('ps2-sched-hours').value));
      params.push('rt=' + encodeURIComponent(document.getElementById('ps2-sched-temp').value));
    }
  }
  return window.location.origin + window.location.pathname + '?' + params.join('&');
}

// Debounced: ps2Calc() runs on every keystroke/slider-tick, but rewriting
// history that often causes visible jank on mobile. The recipe card itself
// still updates synchronously; only the URL write is deferred.
var psUpdateURLTimer = null;
function psUpdateURL() {
  if (!window.history || !window.history.replaceState) return;
  clearTimeout(psUpdateURLTimer);
  psUpdateURLTimer = setTimeout(function() {
    var url = psGenerateShareURL();
    window.history.replaceState(null, '', url);
  }, 400);
}

function psLoadFromURL() {
  var qs = new URLSearchParams(window.location.search);
  if (!qs.has('st') || !psData[qs.get('st')]) return;

  psCurrentStyle = qs.get('st');

  if (qs.has('n')) document.getElementById('ps-ball-count').value = qs.get('n');

  // Diameter is shared in whichever unit the sender was viewing (see 'u'
  // param); restore that unit before applying 'd' so it isn't misread as cm.
  if (qs.has('u') && (qs.get('u') === 'cm' || qs.get('u') === 'in')) {
    psUnit = qs.get('u');
    var diamLbl = document.getElementById('ps-diam-label');
    if (diamLbl) diamLbl.textContent = (psUnit === 'in') ? 'Diameter (in)' : 'Diameter (cm)';
  }

  // psSelectStyle() below resets diameter/width/height to the style's
  // defaults, so custom shared dimensions must be re-applied after it runs.
  psSelectStyle(psCurrentStyle);

  if (qs.has('d')) document.getElementById('ps-diameter').value = qs.get('d');
  if (qs.has('w') && document.getElementById('ps-width')) document.getElementById('ps-width').value = qs.get('w');
  if (qs.has('ht') && document.getElementById('ps-height')) document.getElementById('ps-height').value = qs.get('ht');
  // Re-run Stage 1 so the custom size (not the style default) drives ball
  // weight, and Stage 2's flour weight, before any Stage 2 fields are applied.
  psCalc();

  if (qs.has('h')) { document.getElementById('ps2-hydration').value = qs.get('h'); document.getElementById('ps2-hydration-val').textContent = qs.get('h'); }
  if (qs.has('s')) document.getElementById('ps2-salt').value = qs.get('s');
  if (qs.has('f')) document.getElementById('ps2-fat').value = qs.get('f');
  if (qs.has('yt') && ['idy', 'ady', 'fresh', 'starter'].indexOf(qs.get('yt')) !== -1) {
    ps2SelectYeast(qs.get('yt'));
  }
  if (qs.has('pf') && ['levain', 'poolish', 'biga', 'none'].indexOf(qs.get('pf')) !== -1) {
    ps2SelectPF(qs.get('pf'));
  }
  if (qs.has('pfp')) document.getElementById('ps2-levain-pct').value = qs.get('pfp');
  if (qs.has('lh')) document.getElementById('ps2-levain-hyd').value = qs.get('lh');
  if (qs.has('pp')) document.getElementById('ps2-poolish-pct').value = qs.get('pp');
  if (qs.has('bp')) document.getElementById('ps2-biga-pct').value = qs.get('bp');
  if (qs.has('bh')) document.getElementById('ps2-biga-hyd').value = qs.get('bh');

  if (qs.has('t') || qs.has('rh')) {
    ps2ScheduleOn = true;
    var panel = document.getElementById('ps2-schedule-panel');
    if (panel) panel.style.display = '';
    var toggleBtn = document.getElementById('ps2-schedule-toggle-btn');
    if (toggleBtn) toggleBtn.textContent = 'Hide schedule';
    if (qs.has('rh')) {
      document.getElementById('ps2-sched-room-hours').value = qs.get('rh');
      document.getElementById('ps2-sched-room-temp').value = qs.get('rct') || 22;
      document.getElementById('ps2-sched-fridge-hours').value = qs.get('fh') || 0;
      document.getElementById('ps2-sched-fridge-temp').value = qs.get('ft') || 4;
      ps2ScheduleMode('mixed', null);
    } else {
      document.getElementById('ps2-sched-hours').value = qs.get('t');
      document.getElementById('ps2-sched-temp').value = qs.get('rt') || 22;
      ps2ScheduleMode('single', null);
    }
  }

  ps2Calc();
}

// Light-touch Pro nudge after a third copy or URL-share of a formula.
function psTrackShare() {
  var count = parseInt(localStorage.getItem('dr_ps_share_count') || '0', 10) + 1;
  localStorage.setItem('dr_ps_share_count', String(count));
  if (count === 3) {
    var banner = document.getElementById('ps-pro-nudge-banner');
    if (banner) banner.style.display = '';
  }
}

// Email capture: emails the baker this plan via /api/leads (source calc-result). Kept as a bespoke implementation (not the shared
// snippet) because Pizza Studio's capture banner has its own scoped CSS to match its
// single-page-app shell; the payload/source contract matches the generalised snippet.
function psSubmitCapture(e) {
  e.preventDefault();
  var email = document.getElementById('ps-capture-email').value;
  if (!email) return false;
  // Optional marketing box (snippets/dr-consent.liquid): the formula is sent either way.
  var c = window.drConsent ? window.drConsent(document.getElementById('ps-capture-form')) : { consent: false };

  fetch('https://api.doughrise.store/api/leads', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // P3-03: 'calc-result' plus the formula makes /api/leads email this plan,
    // which is what the banner promises (it used to send a generic welcome).
    body: JSON.stringify({
      email: email,
      consent: c.consent,
      consent_text_version: c.consent_text_version,
      source: 'calc-result',
      calculator: 'pizza-studio',
      formula: psFormulaText()
    })
  }).then(function(r) {
    // P8-01: GA4 dr_plan_emailed, plus dr_newsletter_signup only when the
    // response says this was a new signup (see drGa4PlanEmailed).
    if (r && r.ok && window.drGa4PlanEmailed) window.drGa4PlanEmailed('pizza-studio', r, 'calc-result');
  }).catch(function() {});

  document.getElementById('ps-capture-form').style.display = 'none';
  document.getElementById('ps-capture-success').style.display = '';
  return false;
}

document.addEventListener('DOMContentLoaded', function() {
  psLoadFromURL();
  if (!window.ps) psSelectStyle('neapolitan');
  psInitializing = false;
});

function psHandoffToPro() {
  psTrackExport('pro_handoff');
  var ps = window.ps || {};
  var state = {
    style: ps.style,
    balls: ps.balls,
    ballWeight: ps.ballWeight,
    unit: ps.unit,
    totalFlour: ps.totalFlour,
    totalDough: ps.totalDough,
    hydration: ps.hydration,
    saltPct: ps.saltPct,
    fatPct: ps.fatPct,
    pfType: ps.pfType,
    pfPct: ps.pfPct,
    flourBlend: ps.flourBlend
  };
  var encoded = btoa(JSON.stringify(state));
  window.location.href = 'https://pro.doughrise.store/pizza-studio?state=' + encodeURIComponent(encoded);
}
